(function () {
  var KEY = 'brinkenberg_age_ok';

  function verified() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function setVerified() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function show(gate) {
    gate.style.display = 'flex';
    document.documentElement.style.overflow = 'hidden';
  }

  function hide(gate) {
    gate.style.display = 'none';
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('bb-age-gate');
    if (!gate) return;

    if (verified()) return;

    show(gate);

    var yesBtn = document.getElementById('bb-age-yes');
    var noBtn  = document.getElementById('bb-age-no');
    var msg    = document.getElementById('bb-age-msg');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        setVerified();
        hide(gate);
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', function () {
        if (yesBtn) yesBtn.style.display = 'none';
        noBtn.style.display = 'none';
        if (msg) {
          msg.textContent = 'Helaas, je moet 18 jaar of ouder zijn om onze website te bezoeken.';
          msg.style.display = 'block';
        }
      });
    }
  });
})();
